module.exports = __webpack_public_path__ + "img/3312119.png";